import { defineAsyncComponent } from 'vue'
export default {
  account: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/account.vue").then(m => m.default || m)),
  checkout: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/checkout.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/default.vue").then(m => m.default || m))
}